import { Button } from "antd";
import React from "react";
import Fonts from "../../Config/Fonts";
import Icons from "../../Config/Images";
import Colors from "../../theme/Colors";
import {
  addBtn,
  exportBtn,
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../Utils/CommonStyles/muTableStyle";
import PaginationComponent from "../CustomPagination";

const TableTopView = ({
  exportBtnTxt,
  addBtnTxt,
  onExportBtnPress,
  value,
  onChange,
  onAddButton,
  isAddBtnShow = true,
  isPermissionVisited = false,
  isPagination = true,
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  handlePageChange,
  totalItems,
  rowsPerPageOptions,
  rowsPerPageLabel,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: "20px",
        width: '100%',

      }}
    >
  
    <Search
        style={{
          width: "25%",
          marginTop: "15px",
          marginLeft: "12px",
          borderRadius: "8px",
          border: "1px solid #ccc",
        }}
      >
        <SearchIconWrapper>
          <img
            src={Icons.searchIcon}
            alt="search icon"
            style={{
              height: "15px",
              width: "15px",
              color: "#4A505C",
            }}
          />
        </SearchIconWrapper>
        <StyledInputBase
          value={value}
          onChange={onChange}
          style={{
            fontSize: 14,
            fontWeight: 600,
            fontFamily: Fonts.NunitoSans,
            color: Colors.darkGray,
          }}
          placeholder="Search..."
          inputProps={{ "aria-label": "search" }}
        />
      </Search>

      {!isPermissionVisited && (
        <>
          <Button
            type="default"
            icon={
              <img
                src={Icons.exportIcon}
                alt="export icon"
                style={{ height: "24px", width: "24px" }}
              />
            }
            onClick={onExportBtnPress}
            style={exportBtn}
          >
            {exportBtnTxt}
          </Button>

          {isAddBtnShow && (
            <Button
              onClick={onAddButton}
              type="primary"
              icon={
                <img
                  src={Icons.addIcon}
                  alt="add Icon"
                  style={{ height: "24px", width: "24px" }}
                />
              }
              style={addBtn}
            >
              {addBtnTxt}
            </Button>
          )}
        </>
      )}


     <div style={{width: '48%'}}>
      {isPagination && (
        <PaginationComponent
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalItems={totalItems}
          rowsPerPageLabel={rowsPerPageLabel}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      )}
     </div>
    </div>
  );
};

export default TableTopView;
